import {ThreePillar} from './ThreePillar';

export class ThreePillarVertical extends ThreePillar {
    public getHeight(): number {
        return this.room.getHeight();
    }
}